export interface Docente {
  orden?: number;
  titulacion: string;
  apellido: string;
  nombre: string;
  bio: string;
  linkedin: string;
  mailInstitucional: string;
}

export const docentes: Docente[] = [
  {
    orden: 1,
    titulacion: 'Ing.',
    apellido: 'Conrero',
    nombre: 'Juan Marcelo',
    bio: '',
    linkedin: 'https://www.linkedin.com/in/juan-marcelo-conrero/',
    mailInstitucional: '',
  },
  {
    orden: 2,
    titulacion: '',
    apellido: 'Allende',
    nombre: 'Maria Jose',
    bio: '',
    linkedin: '',
    mailInstitucional: '',
  },
  {
    orden: 3,
    titulacion: '',
    apellido: 'De La Torre',
    nombre: 'Maria Virginia',
    bio: '',
    linkedin: '',
    mailInstitucional: '',
  },
  {
    orden: 4,
    titulacion: '',
    apellido: 'Mansilla',
    nombre: 'Pablo Sebastian',
    bio: '',
    linkedin: '',
    mailInstitucional: '',
  },
  {
    orden: 5,
    titulacion: '',
    apellido: 'Bongiannino',
    nombre: 'Nicolas Francisco',
    bio: '',
    linkedin: '',
    mailInstitucional: '',
  },
  {
    orden: 6,
    titulacion: '',
    apellido: 'Balbo',
    nombre: 'Raquel',
    bio: '',
    linkedin: '',
    mailInstitucional: '',
  },
];
